import React__default from 'react';
import { Heading } from '@grandvisionhq/elements';
import { FeatureIcon } from '@grandvisionhq/icons';
import { useIntl } from '@grandvisionhq/state';

const getFeatures = (getLabel, variant)=>({
        blueFilter: {
            label: getLabel('products.readyreaders.features.blueFilter'),
            hasAttribute: Boolean(variant.features.blueFilter)
        },
        isOfferedWithPrescriptions: {
            label: getLabel('products.readyreaders.features.isOfferedWithPrescriptions'),
            hasAttribute: Boolean(variant.features.isOfferedWithPrescriptions)
        }
    })
;
const ReadyReadersFeatures = ({ variant , labels  })=>{
    const { getLabel  } = useIntl();
    const featureList = getFeatures(getLabel, variant);
    const featureListItems = Object.keys(featureList).map((feature)=>featureList[feature].hasAttribute && /*#__PURE__*/ React__default.createElement("li", {
            className: "ready-readers-features__feature",
            key: feature
        }, /*#__PURE__*/ React__default.createElement(FeatureIcon, {
            name: feature,
            color: 'grey',
            size: 38
        }), featureList[feature].label)
    );
    if (featureListItems.filter(Boolean).length === 0) {
        return null;
    }
    return /*#__PURE__*/ React__default.createElement(React__default.Fragment, null, /*#__PURE__*/ React__default.createElement(Heading, {
        variant: "smallest",
        component: "h2"
    }, labels.informationBlockHeader), /*#__PURE__*/ React__default.createElement("ul", {
        className: "ready-readers-features",
        "aria-label": "features"
    }, featureListItems));
};

export { ReadyReadersFeatures, getFeatures };
//# sourceMappingURL=ReadyReadersFeatures.js.map
